import { CurrentUserStore } from '../../@Component/Domain/User/CurrentUserStore';

export default function getIntercomUserId(currentUserStore: CurrentUserStore): string
{
    const companyName = currentUserStore.environmentEntity.name;

    return currentUserStore ? `TRIBE_${companyName}_${currentUserStore.employeeEntity.id}` : null
}